<template>
  <div class="banner" :class="[`bg-${this.imgPath}`]">
    <div class="bannerInfo baseW">
      <div class="infoMain">
        <div :class="textAlign">
          <h1 :class="currentClass"><span>{{title}}</span></h1>
          <p v-if="content">
            <strong :style="content.style">{{content.text[0]}}</strong>
            <strong :style="content.style">{{content.text[1]}}</strong>
          </p>
          <p v-if="btn">
            <button :style="btn.style" @click="btnClickHandle">{{btn.text}}</button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    content: {
      type: Object,
      default () {
        return {}
      }
    },
    currentClass: {
      type: String,
      default: ''
    },
    btn: {
      type: Object,
      default () {
        return {}
      }
    },
    imgPath: String
  },
  data () {
    return {
      textAlign: ''
    }
  },
  methods: {
    btnClickHandle: function (e) {
      this.$emit('btn-click', e)
    }
  },
  created: function () {
    var href = location.href
    var currentTag = href.substr(href.lastIndexOf('/') + 1) || 'index.html'
    currentTag = currentTag.split('.')[0]
    this.textAlign = currentTag === 'mc' ? 'index' : currentTag
  }
}
</script>
<style lang="scss">
  .bg-index {
    background: url(./images/index/banner.png) no-repeat 0px 0px;
  }
  .bg-supply {
    background: url(./images/supply/banner.png) no-repeat 0px 0px;
  }
  .bg-case {
    background: url(./images/case/banner.png) no-repeat 0px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/bannerInfo/banner.vue